// --- Tipos da config ---

export type ValorFixo = {
  caminho: string;
  valor: unknown;
  sobrescrever: boolean;
};

export type TransformadorRegra =
  | "FORMATAR_LC116_COM_PONTO"
  | "REMOVER_PONTO_LC116"
  | "APENAS_NUMEROS_PAD_7"
  | "REMOVER_ACENTOS_E_ESPECIAIS"
  | "CONVERTER_PARA_FLOAT";

export const REGRAS_DESCRICAO: Record<TransformadorRegra, string> = {
  FORMATAR_LC116_COM_PONTO: "Formatar código LC 116 com ponto (ex: 0107 → 01.07)",
  REMOVER_PONTO_LC116: "Remover ponto do código LC 116 (ex: 01.07 → 0107)",
  APENAS_NUMEROS_PAD_7: "Apenas números, completar com zeros até 7 dígitos",
  REMOVER_ACENTOS_E_ESPECIAIS: "Remover acentos e caracteres especiais",
  CONVERTER_PARA_FLOAT: "Converter para número decimal (ex: \"2.00\" → 2.0)",
};

export type Transformacao = {
  caminho: string;
  regra: TransformadorRegra;
};

export type AdapterConfig = {
  valoresFixos: ValorFixo[];
  deParaChaves: Record<string, string>;
  transformacoes: Transformacao[];
  camposRemover: string[];
};

// --- Tipos do CRUD ---

export type CityAdapterConfigModel = {
  id: number;
  cityIbge: string;
  nomeCidade: string;
  layout: string;
  config: AdapterConfig;
  ativo: boolean;
  createdAt: string;
  updatedAt: string;
};

export type CityAdapterConfigListModel = {
  id: number;
  cityIbge: string;
  nomeCidade: string;
  layout: string;
  ativo: boolean;
  updatedAt: string;
};

export type CityAdapterConfigPageModel = {
  content: CityAdapterConfigListModel[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
};

export type CityAdapterConfigCreateModel = {
  cityIbge: string;
  nomeCidade: string;
  layout: string;
  config: AdapterConfig;
  ativo?: boolean;
};

export type CityAdapterConfigUpdateModel = {
  nomeCidade?: string;
  layout?: string;
  config?: AdapterConfig;
  ativo?: boolean;
};

// --- Preview e Simulação ---

export type AdapterPreviewModel = {
  companyName: string;
  layout: string;
  payload: unknown;
};

export type AdapterSimulateModel = {
  original: unknown;
  transformado: unknown;
};

// --- Interface do service ---

export interface CityAdapterConfigAdmin {
  list: (search: string, page?: number, size?: number) => Promise<CityAdapterConfigPageModel>;
  getByIbge: (ibge: string, layout: string) => Promise<CityAdapterConfigModel>;
  create: (data: CityAdapterConfigCreateModel) => Promise<CityAdapterConfigModel>;
  update: (ibge: string, layout: string, data: CityAdapterConfigUpdateModel) => Promise<CityAdapterConfigModel>;
  remove: (ibge: string, layout: string) => Promise<void>;
  previewPayload: (ibge: string, layout: string) => Promise<AdapterPreviewModel>;
  simulate: (ibge: string, layout: string, config: AdapterConfig) => Promise<AdapterSimulateModel>;
  listConfiguredCities: () => Promise<string[]>;
}

// --- Config vazia (helper) ---

export const EMPTY_CONFIG: AdapterConfig = {
  valoresFixos: [],
  deParaChaves: {},
  transformacoes: [],
  camposRemover: [],
};
